/* @flow */

import getPrimeiroNome from '../usuario/get-primeiro-nome';
import { NOME_SEM_CLIENTE } from '../atendimento/constants';
import { type Pedido } from './types';

const getPrimeiroNomeClientePedido = (pedido: Pedido) => (
    pedido.usuario ? getPrimeiroNome(pedido.usuario.nome) : NOME_SEM_CLIENTE
);

export default getPrimeiroNomeClientePedido;
